/**
 * @module config/apiConfig
 * @description API base URLs and endpoint paths.
 * When deployed to Cloudflare Pages, the API runs on the same origin
 * via Pages Functions, so API_BASE_URL defaults to "" (relative paths).
 */

const isLocalFrontend =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname) &&
  window.location.port !== "3001";

/** Backend base URL (no trailing slash). Empty string = same origin. */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || (isLocalFrontend ? "http://localhost:3001" : "");

/** API endpoint paths. */
export const ENDPOINTS = {
  STARTING_QUESTIONNAIRE: "/api/starting-questionnaire",
  AFTER_IMAGE: "/api/after-image",
  AFTER_PHASE: "/api/after-phase",
  ENDING_QUESTIONNAIRE: "/api/ending-questionnaire",
  LOG: "/api/log",
  PROLIFIC_CONFIG: "/api/prolific/config",
  PROLIFIC_COMPLETE: "/api/prolific/complete",
  PROLIFIC_VALIDATE: "/api/prolific/validate",
  ADMIN_PARTICIPANTS: "/api/admin/participants",
  ADMIN_QUESTIONNAIRES: "/api/admin/questionnaires",
  ADMIN_SUMMARY: "/api/admin/summary",
  ADMIN_ACTIVITY: "/api/admin/activity",
};
